<template>
  <div id="modal-envio">
    <dialog-default
      :open.sync="myOpen"
      :width="width"
      :top="top"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :destroy-on-close = destroy
      :fullscreen="fullscreen"
      :hidden-title="sending || mostrarErro"
    >
      <template v-slot:title  v-if="!sending && !mostrarErro">
        <slot name="title">
          <div class="default-dialog-title-box">
            <el-row>
              <el-col
                  :xs="20"
                  :sm="20"
                  :md="20"
                  :lg="20"
                  :xl="20"
              >
                <h3 class="default-dialog-title">{{ title }}</h3>
              </el-col>
              <el-col
                  :xs="4"
                  :sm="4"
                  :md="4"
                  :lg="4"
                  :xl="4"
              >
                <p
                    class="default-dialog-close text-right"
                    @click="close()"
                >
                  FECHAR
                </p>
              </el-col>
            </el-row>
          </div>
        </slot>
      </template>

      <slot>
        <div v-if="!sending && !mostrarErro">
          <el-row>
            <el-col>
              <p class="label"><b>O que deseja enviar?</b></p>
              <el-select
                v-model="opcaoEnvio"
                class="form-select"
                data-vv-as="opcaoEnvio"
                name="opcaoEnvio"
                placeholder="Selecione..."
                value-key="opcaoEnvio"
                :disabled="listaOpcoes.length < 1"
              >
                <el-option
                  v-for="(item, index) in listaOpcoes"
                  :key="index"
                  :label="item.nome"
                  :value="index"
                >
                  {{ item.nome }}
                </el-option>
              </el-select>
            </el-col>
            <el-col v-if="listaOpcoes.length < 1" style="margin-top:35px;">
              <el-alert
                title="Este item não possui opções de envio disponível."
                type="default"
                center
                :closable="false"
                style="padding:20px 0; background-color: #F6F6F6"
              >
              </el-alert>
            </el-col>
            <el-col  style="margin-top: 20px" v-if="listaOpcoes.length > 0">
              <p class="label"><b>Enviar para qual canal?</b></p>
                <el-checkbox v-model="escolhasEnvio" :label="metodo" v-for="(metodo, index) in metodoEnvio" :key="index" style="margin-top: 10px; padding:5px 0">
                    <span>{{ metodo.tipo.descricao }}</span>
                    <el-input size="mini" v-if="metodo.tipo.id === 2" v-model="emailEnvio" style="margin-left: 10px" />
                    <el-input size="mini" v-if="metodo.tipo.id === 3" v-model="whatsappEnvio" style="margin-left: 10px" />
                </el-checkbox>
            </el-col>
          </el-row>
          <el-row>
          <el-col :span=12 :push="12">
            <ButtonDefault
              title="Enviar"
              :disabled="desabilitaEnviar"
              @click="sendAction()"
            />
          </el-col>
        </el-row>
        </div>
        <div v-if="sending" style="">
          <div
            style="text-align: center; font: normal normal 600 18px/24px Open Sans; letter-spacing: 0; color: #333333; opacity: 1; margin-bottom: 20px; padding: 30px;">
            <img src="../../assets/img/Modal_sended.png" alt="none" /><br/>
            Enviado!
          </div>
          <ButtonDefault title="ENTENDI" @click="sending = false" />
        </div>
        <div v-if="mostrarErro">
          <div
            style="text-align: center; font: normal normal 600 18px/24px Open Sans; letter-spacing: 0; color: #333333; opacity: 1; margin-bottom: 20px;">
            Erro no envio
          </div>
          <div
            style="text-align: center; font: normal normal normal 14px/19px Open Sans; letter-spacing: 0; color: #000000; opacity: 0.8;">
            Não foi possível enviar seu arquivo. <br>
            Tente novamente mais tarde.
          </div>
          <ButtonDefault title="ENTENDI" @click="mostrarErro = false" />
        </div>
      </slot>
      <template v-slot:footer>
      </template>
    </dialog-default>
  </div>
</template>
<script>

import ButtonDefault from '@/components/buttons/ButtonDefault'
import configuraRequestFuncionalidade from '@/components/ModalEnvio/RegraDeNegocio'
import mshubPayload from '@/utils/mshubPayload'
import { telefoneFormatter } from '@/utils/formatter'
import { mapGetters, mapState } from 'vuex'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'ModalEnvio',
  components: { DialogDefault, ButtonDefault },
  props: {
    title: {
      type: String,
      default: ''
    },
    destroy: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '15vh'
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    payloadWidget: {
      type: Function
    }
  },
  watch: {
    async open (newValue) {
      if (newValue) {
        this.opcaoEnvio = ''
        this.emailEnvio = this.user.contato ? this.user.contato.email : ''
        this.whatsappEnvio = this.user.contato ? telefoneFormatter(this.user.contato.telefoneCelular) : ''
        this.escolhasEnvio = []
        this.sending = false
        this.mostrarErro = false
        const payload = await this.trataExclusoes(await this.payloadWidget())
        if (payload) {
          this.preLoadWidget = payload
          this.listaOpcoes = payload.opcoesDeEnvio
          this.metodoEnvio = payload.configuracao.metodoEnvio
        }
      }
      this.myOpen = newValue
    },
    myOpen (newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.close()
      }
    }
  },
  data () {
    return {
      myOpen: false,
      escolhasEnvio: [],
      opcaoEnvio: '',
      listaOpcoes: [],
      metodoEnvio: [],
      emailEnvio: '',
      whatsappEnvio: '',
      preLoadWidget: '',
      sending: false,
      mostrarErro: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao']),
    ...mapState('SetupApp', ['frameId', 'apiUtilitarios', 'protocolo', 'origemEmbed']),
    ...mapGetters('Login', ['user', 'token']),
    desabilitaEnviar () {
      return !(this.opcaoEnvio !== '' && (this.escolhasEnvio.length > 0))
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.myOpen = this.open
    },
    close () {
      this.$emit('update:open', false)
      this.$emit('close', false)
    },
    async sendWidgetAction (escolha) {
      try {
        // enviar mais dado sdo preloadWidget
        let payloadConfiguracaoIntegracao = mshubPayload({
          idRotina: 'widget',
          metodoEnvio: escolha,
          integracao: this.preLoadWidget.opcoesDeEnvio[this.opcaoEnvio].integracao,
          data: {
            ...this.preLoadWidget.data,
            ...this.preLoadWidget.opcoesDeEnvio[this.opcaoEnvio].data,
            chaveUnica: this.user.chaveUnica,
            protocolo: this.protocolo,
            origemEmbed: this.origemEmbed
          }
        })

        switch (escolha.tipo.id) {
          case 2:
            payloadConfiguracaoIntegracao.negocio.metodoEnvio.contato = this.emailEnvio
            break
          case 3:
            payloadConfiguracaoIntegracao.negocio.metodoEnvio.contato = this.whatsappEnvio
            break
          default:
        }

        payloadConfiguracaoIntegracao.negocio.integracao.headers.Authorization = this.token
        await this.apiUtilitarios.acionarFilaWidget({
          loading: true,
          payload: {
            ...payloadConfiguracaoIntegracao
          },
          notifyFailure: true,
          handlerErrorIgnore: false
        })
        const payload = {
          uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
          origin: 'omnichannel',
          client: this.frameId,
          type: 'command',
          command: 'UPDATE_ATEND_ATIVO',
          data: {
          },
          timestamp: Date.now()
        }
        this.sending = true
        window.parent.postMessage(payload, '*')
        this.sending = true
      } catch (e) {
        this.sending = false
        this.mostrarErro = true
      }
    },
    async sendWidgetMosiaAction () {
      try {
        const opcaoEnvio = this.listaOpcoes[this.opcaoEnvio]
        const acionaFuncionalidade = configuraRequestFuncionalidade[this.preLoadWidget.idFuncionalidade]
        const request = await acionaFuncionalidade(opcaoEnvio)
        if (!request.status) {
          throw Error(request.message)
        }
        const payload = {
          uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
          origin: 'omnichannel',
          client: this.frameId,
          type: 'command',
          command: 'SEND_WIDGET',
          data: {
            ...request.data
          },
          timestamp: Date.now()
        }
        this.sending = true
        window.parent.postMessage(payload, '*')
      } catch (e) {
        this.sending = false
        this.mostrarErro = true
      }
    },
    sendAction () {
      this.escolhasEnvio.forEach((escolha) => {
        switch (escolha.tipo.id) {
          case 1:
            return this.sendWidgetMosiaAction()
          case 2:
            return this.sendWidgetAction(escolha)
          case 3:
            return this.sendWidgetAction(escolha)
          default:
            return false
        }
      })
    },
    async trataExclusoes (payloadWidget) {
      if (this.origemEmbed === 'ocorrencia') {
        const found = payloadWidget.configuracao.metodoEnvio.findIndex(element => element.tipo.descricao === 'Mensagem no chat')
        if (found !== -1) {
          payloadWidget.configuracao.metodoEnvio.splice(found, 1)
        }
      }
      return payloadWidget
    }
  }
}
</script>
<style lang="less" scoped>
#modal-envio {
  text-align: left;

  .default-dialog {
    background: #FFFFFF 0 0 no-repeat padding-box;
    border-radius: 8px;
    /*margin-top: 5vh !important;*/
  }

  .default-dialog-title-box {
    padding-bottom: 12px;
    border-bottom: 1px solid #CCCCCC;
  }

  .default-dialog-title {
    font: normal normal 600 24px/29px Open Sans;
    font-weight: 600;
    letter-spacing: 0;
    color: #333333;
  }

  .default-dialog-close {
    font: normal normal 600 13px/16px Open Sans;
    font-weight: 600;
    letter-spacing: 0;
    color: #1074FF;
    cursor: pointer;
  }

  .default-dialog-footer-box {
    padding: 10px;
    border-top: 1px solid #CCCCCC;
  }

  .default-dialog-container {
    overflow: auto;
    /*max-height: 70vh;*/
    max-height: 50vh;
  }
}
</style>
